/* Melts Infusions theme layer — small, dependency-free. Works alongside Dawn's global.js / product-form.js / cart-drawer.js */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Header shadow on scroll */
  var header = $('[data-m-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Mobile drawer */
  var drawer = $('[data-m-drawer]');
  if (drawer) {
    var opener = $('[data-m-drawer-open]');
    var open = function () {
      drawer.setAttribute('open', ''); drawer.setAttribute('aria-hidden', 'false');
      opener && opener.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('a, button'); f && f.focus();
    };
    var close = function () {
      drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden', 'true');
      opener && opener.setAttribute('aria-expanded', 'false'); document.body.style.overflow = '';
      opener && opener.focus();
    };
    opener && opener.addEventListener('click', open);
    $$('[data-m-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.hasAttribute('open')) close(); });
  }

  /* Announcement rotation (mobile shows one at a time) */
  $$('[data-m-rotate]').forEach(function (bar) {
    var items = $$('.m-announce__item', bar); if (items.length < 2) return;
    var i = 0, ms = (parseInt(bar.dataset.mRotate, 10) || 5) * 1000;
    setInterval(function () {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, ms);
  });

  /* Reveal on scroll (respects reduced motion via CSS) */
  var reveals = $$('.m-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Tabs (comparison table) */
  $$('m-tabs').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    var select = function (t) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    };
    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = tabs[(idx + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; select(n); n.focus();
        }
      });
    });
  });

  /* ---------- Product page ---------- */
  $$('[data-m-pdp]').forEach(function (pdp) {
    var sid = pdp.dataset.section;
    var dataEl = document.querySelector('[data-m-product-json="' + sid + '"]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    /* Money strings: the store's money format may carry HTML (e.g. a currency app's <span class=money>). Always show plain text. */
    var plain = function (s) {
      if (s == null) return '';
      s = String(s);
      if (s.indexOf('<') === -1 && s.indexOf('&') === -1) return s;
      try { return (new DOMParser().parseFromString(s, 'text/html').body.textContent || '').trim(); } catch (e) { return s.replace(/<[^>]*>/g, ''); }
    };
    (data.variants || []).forEach(function (v) {
      v.price_f = plain(v.price_f); v.compare_f = plain(v.compare_f);
      if (v.plans) Object.keys(v.plans).forEach(function (k) { v.plans[k].price_f = plain(v.plans[k].price_f); });
    });
    var idInput = $('[data-m-id]', pdp);
    var planInput = $('[data-m-selling-plan]', pdp);
    var planSelect = $('[data-m-plan-select]', pdp);
    var atcBtn = $('[data-m-atc]', pdp);
    var sticky = document.querySelector('[data-m-sticky]');

    var currentVariant = function () {
      var id = parseInt(idInput ? idInput.value : 0, 10);
      return data.variants.filter(function (v) { return v.id === id; })[0] || data.variants[0];
    };
    var isSub = function () {
      var r = $('[data-m-purchase]:checked', pdp); return !!(r && r.value === 'subscribe');
    };
    var setText = function (sel, txt, root) { $$(sel, root || pdp).forEach(function (el) { el.textContent = txt; }); };

    var render = function () {
      var v = currentVariant();
      var planId = planSelect ? planSelect.value : null;
      var alloc = planId && v.plans ? v.plans[planId] : null;
      var sub = isSub() && alloc;
      if (planInput) { planInput.disabled = !sub; planInput.value = sub ? planId : ''; }
      var now = sub ? alloc.price_f : v.price_f;
      setText('[data-m-price]', now);
      setText('[data-m-atc-price]', now);
      var cmp = $('[data-m-compare]', pdp);
      if (cmp) {
        if (sub) { cmp.textContent = v.price_f; cmp.hidden = false; }
        else if (v.compare > v.price) { cmp.textContent = v.compare_f; cmp.hidden = false; }
        else { cmp.hidden = true; }
      }
      var save = $('[data-m-save]', pdp);
      if (save) {
        var base = sub ? v.price : v.compare;
        var cur = sub ? alloc.price : v.price;
        if (base > cur) { save.textContent = 'Save ' + Math.round((base - cur) * 100 / base) + '%'; save.hidden = false; } else { save.hidden = true; }
      }
      if (alloc) {
        setText('[data-m-sub-price]', alloc.price_f); setText('[data-m-sub-compare]', v.price_f);
        var pct = Math.round((v.price - alloc.price) * 100 / v.price);
        $$('[data-m-sub-pct]', pdp).forEach(function (el) { el.textContent = 'Save ' + pct + '%'; el.hidden = pct <= 0; });
      }
      setText('[data-m-onetime-price]', v.price_f);
      if (atcBtn) {
        atcBtn.disabled = !v.available; atcBtn.setAttribute('aria-disabled', String(!v.available));
        setText('[data-m-atc-label]', v.available ? data.atc : data.soldout);
      }
      if (sticky) {
        $$('[data-m-sticky-price]', sticky).forEach(function (el) { el.innerHTML = ''; el.appendChild(document.createTextNode(now + ' ')); if (sub) { var s = document.createElement('s'); s.textContent = v.price_f; el.appendChild(s); } });
        var sb = $('[data-m-sticky-btn]', sticky); if (sb) sb.disabled = !v.available;
      }
    };

    var setVariant = function (id) {
      if (!idInput) return;
      idInput.value = id;
      try {
        var url = new URL(window.location.href); url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      render();
    };

    $$('[data-m-variant-radio]', pdp).forEach(function (r) { r.addEventListener('change', function () { setVariant(r.value); }); });
    var vs = $('[data-m-variant-select]', pdp); if (vs) vs.addEventListener('change', function () { setVariant(vs.value); });
    $$('[data-m-purchase]', pdp).forEach(function (r) { r.addEventListener('change', render); });
    if (planSelect) planSelect.addEventListener('change', render);
    render();

    /* Gallery: thumbs + dots */
    var slides = $('[data-m-slides]', pdp);
    if (slides) {
      var thumbs = $$('[data-m-thumb]', pdp);
      var dots = $$('.m-gallery__dots span', pdp);
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.mThumb, 10);
          slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
        });
      });
      var tick;
      slides.addEventListener('scroll', function () {
        cancelAnimationFrame(tick);
        tick = requestAnimationFrame(function () {
          var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
          thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        });
      }, { passive: true });
    }

    /* Sticky add-to-cart */
    var buy = document.getElementById('MBuyButtons-' + sid);
    if (sticky && buy && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.m-footer');
      var buyVisible = true, footerVisible = false;
      var upd = function () {
        var show = !buyVisible && !footerVisible && buy.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        var b = $('[data-m-sticky-btn]', sticky); if (b) b.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; upd(); }).observe(buy);
      if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; upd(); }).observe(footer);
      var raf; window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
      var sbtn = $('[data-m-sticky-btn]', sticky);
      sbtn && sbtn.addEventListener('click', function () {
        var form = buy.querySelector('form');
        if (form && form.requestSubmit) { form.requestSubmit(); } else if (atcBtn) { atcBtn.click(); }
      });
    }
  });
})();
